export default __webpack_public_path__ + "static/media/03-hole-cx.9661ef1c.gif";